function Header() {
  return (
    <header>
        <nav>
            <div className="logo">
                <a href="#home"><img src="images/logo.jpg" alt="GMED logo" /></a>
            </div>
            <div className="menu-toggle" id="mobileMenu">
                <span></span>
                <span></span>
                <span></span>
            </div>
            <ul className="nav-links" id="navLinks">
                <li><a href="#home">Home</a></li>
                <li><a href="#sobre">Quem Somos</a></li>
                <li><a href="#beneficios">Benefícios</a></li>
                <li><a href="#equipamentos">Equipamentos</a></li>
                <li><a href="#contato">Contato</a></li>
            </ul>
        </nav>
    </header>
  );
}

export default Header;
